import { render, staticRenderFns } from "./EnterpriseCommentsTabComponent.vue?vue&type=template&id=3c98c1fa&scoped=true"
import script from "./EnterpriseCommentsTabComponent.js?vue&type=script&lang=js&external"
export * from "./EnterpriseCommentsTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./EnterpriseCommentsTabComponent.vue?vue&type=style&index=0&id=3c98c1fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c98c1fa",
  null
  
)

export default component.exports